import {
  AppBar,
  Box,
  Button,
  debounce,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import FileIcon from "@mui/icons-material/FileUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { Download } from "@mui/icons-material";
import { useAppSelector, useAppDispatch } from "../../../../../../../hooks/store-hooks";
import { Transition } from "../../../../../../../components";
import { useListaCboService } from "../../../../../../../../use-cases/geo-veles/lista-cbo";
import { setEditListaCboRemoveState } from "../../../../../../../../application/states/geo-veles/lista-cbo";

export const EditListaCbosForm = (props: { openForm: boolean }) => {
  const { listaCbo } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  const [cboSearchTerm, setCboSearchTerm] = useState<string>("");
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState<boolean>(false);
  const [cboToDelete, setCboToDelete] = useState<string>("");

  const {
    setEditListaCboNome,
    closeEditListaCbo,
    openImportFileListaCbos,
    updateListaCbo,
  } = useListaCboService();

  const handleOpenConfirmDelete = (cbo: string) => {
    setCboToDelete(cbo);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    dispatch(setEditListaCboRemoveState({ cbo: cboToDelete }));
    setConfirmDeleteOpen(false);
    setCboToDelete("");
  };

  const handleCancelDelete = () => {
    setConfirmDeleteOpen(false);
    setCboToDelete("");
  };

  const cidadesArray = Array.isArray(listaCbo.editListaCboForm.fields.CBOs)
    ? listaCbo.editListaCboForm.fields.CBOs
    : [];

  const filteredCbos = cidadesArray.filter((cbo) =>
    cboSearchTerm
      ? cbo.toLowerCase().includes(cboSearchTerm.toLowerCase())
      : true
  );

  return (
    <>
      {props.openForm === true && (
        <>
          <Dialog
            fullScreen
            open={listaCbo.openEditListaCbo}
            TransitionComponent={Transition}
            onClose={() => {
              closeEditListaCbo();
            }}
          >
            <AppBar sx={{ position: "relative" }}>
              <Toolbar>
                <Typography
                  sx={{ ml: 2, flex: 1 }}
                  textTransform="uppercase"
                  variant="h6"
                  component="div"
                >
                  Editar - {listaCbo.editListaCboForm.fields.Nome}
                </Typography>
                <Button
                  autoFocus
                  color="inherit"
                  onClick={() => {
                    closeEditListaCbo();
                  }}
                >
                  Fechar
                </Button>
              </Toolbar>
            </AppBar>
            <Box p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome da lista"
                    placeholder="Digite o nome da lista"
                    defaultValue={listaCbo.editListaCboForm.fields.Nome}
                    onChange={debounce((e) => {
                      setEditListaCboNome(e.target.value);
                    }, 500)}
                  />

                  <Button
                    startIcon={<Download />}
                    color="primary"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 2,
                      textTransform: "uppercase",
                      textDecoration: "none",
                      color: "white",
                      "&:hover": {
                        color: "white",
                        textDecoration: "none",
                      },
                    }}
                    component="a"
                    href="/Modelo_CboList.xlsx"
                    download="Planilha_Modelo_CBO.xlsx"
                  >
                    Baixar Modelo de planilha
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Paper elevation={3}>
                    <Box p={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            textTransform="uppercase"
                            color="primary"
                          >
                            Adicionar Lista de CBOs
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              startIcon={<FileIcon />}
                              variant="contained"
                              onClick={(e) => {
                                e.preventDefault();
                                openImportFileListaCbos(true);
                              }}
                            >
                              Clique aqui para Importar arquivo
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Pesquisar CBO"
                    placeholder="Digite o CBO que deseja pesquisar"
                    fullWidth
                    value={cboSearchTerm}
                    onChange={(e) => {
                      setCboSearchTerm(e.target.value);
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography color="primary" variant="h6">
                    Tamanho: {cidadesArray.length.toLocaleString("pt-BR")}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  height={filteredCbos.length <= 3 ? 175 : 250}
                  maxHeight={400}
                >
                  <AutoSizer>
                    {({ width }: { width: number }) => (
                      <FixedSizeList
                        width={width}
                        height={filteredCbos.length <= 3 ? 175 : 250}
                        style={{ maxHeight: 400 }}
                        itemSize={46}
                        itemCount={filteredCbos.length}
                        overscanCount={15}
                      >
                        {({ index, style }) => {
                          const item = filteredCbos[index];
                          return (
                            <ListItem
                              style={style}
                              secondaryAction={
                                <Button
                                  onClick={() => handleOpenConfirmDelete(item)}
                                  startIcon={<DeleteIcon />}
                                  color="error"
                                >
                                  Excluir
                                </Button>
                              }
                            >
                              <ListItemText primary={item} />
                            </ListItem>
                          );
                        }}
                      </FixedSizeList>
                    )}
                  </AutoSizer>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    fullWidth
                    onClick={(e) => {
                      e.stopPropagation();
                      updateListaCbo();
                    }}
                    variant="contained"
                  >
                    Salvar alterações
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Dialog>

          {/* CONFIRMAÇÃO EXCLUSÃO*/}
          <Dialog
            open={confirmDeleteOpen}
            onClose={handleCancelDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Confirmar Exclusão
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Tem certeza que deseja excluir o CBO <strong>{cboToDelete}</strong>?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCancelDelete} color="primary">
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmDelete}
                color="error"
                autoFocus
                variant="contained"
              >
                Excluir
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};